import { fetchAuthSession } from "aws-amplify/auth";
import axios from "axios";

export const api = axios.create();
export const apiWithAuth = axios.create();

// Request interceptor
apiWithAuth.interceptors.request.use(
  async (config) => {
    try {
      const { tokens } = await fetchAuthSession();
      const token = await tokens?.idToken.toString();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token;
      }
    } catch (error) {
      console.log(error);
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
